import React, { useState, useEffect, useRef } from "react";
import { Skeleton } from "@mui/material";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import { useNetwork } from "../../../context/NetworkContext";
import { useShowAlert } from "../../../context/AlertContext";
import AxiosInstance from "../../../utils/AxiosInstance";
import handleError from "../../../constants/handleError";
import AddStock from "./AddStock";
import EditStock from "./EditStock";
import StockIn from "./StockIn";
import StockOut from "./StockOut";
import DateConverter from "@heartinz/date_and_time_processor";
import Messages from "../../../constants/Messages";
import { useAuth } from "../../../context/AuthProvider";
import { usePermission } from "../../../context/PermissionContext";
import useKeyboardTableNavigation from "../../../constants/useKeyboardTableNavigation";
import { useContextApi } from "../../../context/ContextApi";
import Table from "../../../constants/Table";
import BarcodeGenerator from "../product/BarCode";
import uRLs from "../../../utils/baseUtils";
import { useLocation, useNavigate } from "react-router";
import { toPrimaryQuantity, toSecondaryQuantity } from "@heartinz/finance";
import { secondaryQuanity } from "../../../utils/ProductHandleChange";
import { formatCurrencyFun } from "../../../utils/formatCurrencyFunc";
import { ArrowBackIcon, BarcodeIcon, DeleteIcon } from "../../../constants/Icons";

const Stock = ({ isActive,onDone }) => {
  const [isBtnLoading, setBtnLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isStockData, setStockData] = useState([]);
  const [recenetStock, setRecentStock] = useState([]);
  const [isAnyInputFocused, setIsAnyInputFocused] = useState(false);
  const perPage = 10;
  const [showBarcodeModal, setShowBarcodeModal] = useState(false);
  const [selectedBarcode, setSelectedBarcode] = useState("");
  const [isStockEditModalOpen, setStockEditModalOpen] = useState(false);
  const [isStockEditData, setStockEditData] = useState("");
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  const { isUser } = useAuth();
  const { getColor } = useContextApi();
  const { permission, hasPermission, globelPopupOpen } = usePermission();
  const [isStockInModalOpen, setStockInModalOpen] = useState(false);
  const [isStockInData, setStockInData] = useState("");
  const [isStockOutModalOpen, setStockOutModalOpen] = useState(false);
  const [isStockOutData, setStockOutData] = useState("");
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [isProductEditData, setProductEditData] = useState(null);
  const [isProductData, setProductData] = useState([]);
  const [searchOpen, setSearchOpen] = useState(false);
  const [noteSuggest, setNoteSuggest] = useState([]);
  const [noteOpen, setNoteOpen] = useState(false);
  const hasFetched = useRef(false);
  const [brandSuggest,setBrandSuggest]=useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const { navigatelist } = location?.state || {};
  const [productStockData,setProductStockData]=useState(null)

  const closeEditModal = () => {
    setStockEditModalOpen(false);
    setStockEditData("");
  };

  const handleNoteOpen = (status) => {
    setNoteOpen(status);
  };

  const closeStockInModal = () => {
    setStockInModalOpen(false);
    setStockInData("");
  };

  const openStockInModal = (cItem, index) => {
    if (
      hasPermission("STOCK", "STOCK:updateStockin") ||
      permission === undefined
    ) {
      setStockInModalOpen(true);
      cItem.cIndex = index;
      setStockInData(cItem);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleClickBarcode = (code) => {
    if (
      hasPermission("PRODUCT", "PRODUCT:viewByCode") ||
      permission === undefined
    ) {
      setSelectedBarcode(code); // set the selected barcode
      setShowBarcodeModal(true); // show the modal
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const openDeleteTrashModal = (cItem, index) => {
    if (
      hasPermission("STOCK", "STOCK:deleteTrash") ||
      permission === undefined
    ) {
      setStockOutModalOpen(true);
      cItem.cIndex = index;
      setStockOutData(cItem);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const closeStockOutModal = () => {
    setStockOutModalOpen(false);
    setStockOutData("");
  };

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const closeProductEditModal = () => {
    setProductEditData(null);
    setEditModalOpen(false);
  };

  const primaryQuanity=(quanity,unitData)=>{
    const qty=toPrimaryQuantity(quanity, unitData);
    return qty?.primaryQty;
  }

  const handleUpdate = async (updatedData) => {
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const data = {
        productid: updatedData.productid,
        // stockid: updatedData._id,
        ...(updatedData?.manufacturedate && {
          manufacturedate: DateConverter.convertToTimeZone(
            updatedData?.manufacturedate,
            isUser.timezone,
          ),
        }),
        ...(updatedData?.expiredate && {
          expiredate: DateConverter.convertToTimeZone(
            updatedData?.expiredate,
            isUser.timezone,
          ),
        }),
        mrp: CurrencyConverter.toSubunit(updatedData.mrp, "INR"),
        saleprice: CurrencyConverter.toSubunit(updatedData.saleprice, "INR"),
        taxpercentage: updatedData.taxpercentage,
        // discount: CurrencyConverter.toSubunit(updatedData.discount, "INR"),
        baseprice: CurrencyConverter.toSubunit(updatedData.baseprice, "INR"),
        taxamount: CurrencyConverter.toSubunit(updatedData.taxamount, "INR"),
        isLock: updatedData.isLock,
        landingcost: CurrencyConverter.toSubunit(
          updatedData.landingcost || 0,
          "INR",
        ),
      };
      const response = await AxiosInstance.patch(
        `module/stock/${updatedData._id}`,
        data,
      );
      var index = updatedData.cIndex;
      const updatedDatas = response.data.results;

      setStockData((prevStock) =>
        prevStock.map((item) =>
          item.stockLinkId === updatedDatas.stockLinkId
            ? { ...item, ...updatedDatas }
            : item,
        ),
      );

      const stockValue = updatedData?.isSecondaryUnit
        ? primaryQuanity(updatedData?.stock||0, updatedData?.unitConfig)
        : updatedData.stock ||0;
      if (stockValue > 0.0) {
        if (updatedData?.stockLeft < stockValue) {
          await handleStockInUpdate(updatedData);
        } else if (updatedData.stockLeft >= stockValue) {
          if (updatedData.stockLeft >= stockValue) {
            await handleStockTrashUpdate(updatedData);
          } else {
            console.log("insufficient Stock");
          }
        } else {
          console.log("euql");
        }
      }

      setRecentStock((perv) => {
        const savedStocks =
          JSON.parse(localStorage.getItem("recentStocks")) || [];
        const updatedStocks = savedStocks.map((item) =>
          item.productid === updatedDatas.productid
            ? { ...item, ...updatedDatas }
            : item,
        );
        localStorage.setItem("recentStocks", JSON.stringify(updatedStocks));
        return updatedStocks;
      });

      showAlert("success", Messages.SUCCESS.STOCK_UPDATED);
      closeEditModal();
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

  const handleBrandSuggest=async()=>{
    try{
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(`module/product/brand/suggestion`);
      const result=response?.data?.results;
      setBrandSuggest(result)
    }catch(error){
      handleError(error, showAlert);
      return false;
    }
  }

  const openEditModal = (cItem, cIndex) => {
    if (hasPermission("STOCK", "STOCK:update") || permission === undefined) {
      const isValidDate = (date) => date && !isNaN(new Date(date).getTime());
      setStockEditData({
        ...cItem,
        mrp: CurrencyConverter.toCurrency(cItem?.mrp, "INR"),
        saleprice: CurrencyConverter.toCurrency(cItem?.saleprice, "INR"),
        discount: CurrencyConverter.toCurrency(cItem?.discount, "INR"),
        baseprice: CurrencyConverter.toCurrency(cItem?.baseprice, "INR"),
        taxamount: CurrencyConverter.toCurrency(cItem?.taxamount, "INR"),
        landingcost: CurrencyConverter.toCurrency(
          cItem?.landingcost || 0,
          "INR",
        ),
        manufacturedate: isValidDate(cItem?.manufacturedate)
          ? DateConverter.ISOToDisplayFormat(
              DateConverter.toISO(
                formatDate(new Date(cItem?.manufacturedate)),
                "yyyy-MM-dd",
                isUser.timezone,
              ),
            ).date
          : "",
        expiredate: isValidDate(cItem?.expiredate)
          ? DateConverter.ISOToDisplayFormat(
              DateConverter.toISO(
                formatDate(new Date(cItem?.expiredate)),
                "yyyy-MM-dd",
                isUser.timezone,
              ),
            ).date
          : "",
        cIndex: cIndex,
      });
      setStockEditModalOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleSuggestNote = async () => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(
        `module/product/note/suggestion?language=en`,
      );

      setNoteSuggest(response.data.results || []);
      // setShowNotePopup(true);
    } catch (error) {
      handleError(error, showAlert);
      return false;
    }
  };

  const handleStockInUpdate = async (updatedData, quantity) => {
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const data = {
        productid: updatedData?.productid,
        stocklinkid: updatedData?.stockLinkId,
        // quantity: Number((updatedData?.stock - updatedData?.stockLeft).toFixed(3)),
        quantity :Number(updatedData?.isSecondaryUnit ?
          ((primaryQuanity(updatedData?.stock,updatedData?.unitConfig) - updatedData?.stockLeft ).toFixed(3)):
          (updatedData?.stock - updatedData?.stockLeft).toFixed(3),
        ),
      };
      const response = await AxiosInstance.patch(
        `module/stock/stockin/${updatedData?._id}`,
        data,
      );
      var index = updatedData.cIndex;
      updatedData = response.data.results;

      setStockData((prevStock) =>
        prevStock.map((item) =>
          item.productid === updatedData.productid
            ? {
                ...item,
                stockIn: updatedData.stockIn,
                stockLeft: updatedData.stockLeft,
              }
            : item,
        ),
      );

      setRecentStock((prev) => {
        const savedStocks =
          JSON.parse(localStorage.getItem("recentStocks")) || [];
        const updatedStocks = savedStocks.map((item) =>
          item.productid === updatedData.productid
            ? {
                ...item,
                stockIn: updatedData.stockIn,
                stockLeft: updatedData.stockLeft,
              }
            : item,
        );
        localStorage.setItem("recentStocks", JSON.stringify(updatedStocks));
        return updatedStocks;
      });

      showAlert("success", Messages.SUCCESS.STOCK_UPDATED);
      closeStockInModal();
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

  const handleStockIn = async (updatedData, quantity) => {
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const data = {
        productid: updatedData?.productid,
        // stockid: updatedData._id,
        stocklinkid: updatedData?.stockLinkId,
        quantity: quantity,
      };
      const response = await AxiosInstance.patch(
        `module/stock/stockin/${updatedData?._id}`,
        data,
      );
      var index = updatedData.cIndex;
      updatedData = response.data.results;

      // setStockData((prevStock) => {
      //   if (prevStock[index]?._id === updatedData._id) {
      //     const updatedStock = [...prevStock];
      //     updatedStock[index] = { ...prevStock[index], ...updatedData };
      //     return updatedStock;
      //   }
      //   return prevStock.map((item) =>
      //     item._id === updatedData._id ? { ...item, ...updatedData } : item
      //   );
      // });

      setStockData((prevStock) =>
        prevStock.map((item) =>
          item.productid === updatedData.productid
            ? {
                ...item,
                stockIn: updatedData.stockIn,
                stockLeft: updatedData.stockLeft,
              }
            : item,
        ),
      );

      setRecentStock((prev) => {
        const savedStocks =
          JSON.parse(localStorage.getItem("recentStocks")) || [];
        const updatedStocks = savedStocks.map((item) =>
          item.productid === updatedData.productid
            ? {
                ...item,
                stockIn: updatedData.stockIn,
                stockLeft: updatedData.stockLeft,
              }
            : item,
        );
        localStorage.setItem("recentStocks", JSON.stringify(updatedStocks));
        return updatedStocks;
      });

      showAlert("success", Messages.SUCCESS.STOCK_UPDATED);
      closeStockInModal();
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

  const handleStockTrashUpdate = async (updatedData, quantity, remarks) => {
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const data = {
        productid: updatedData.productid,
        stockid: updatedData._id,
        // ...(remarks && { remarks }),
        remarks: "Stock Trashed",
        // quantity: Number((updatedData.stockLeft - updatedData?.stock).toFixed(3)),
        quantity: Number(updatedData?.isSecondaryUnit ?
          ((updatedData.stockLeft - primaryQuanity(updatedData?.stock,updatedData?.unitConfig)).toFixed(3)):
          (updatedData.stockLeft - updatedData?.stock).toFixed(3),
        ),
      };
      const response = await AxiosInstance.delete(
        `module/stock/trash/${updatedData.stockLinkId}`,
        { data },
      );
      var index = updatedData.cIndex;
      updatedData = response.data.results;

      setStockData((prevStock) =>
        prevStock.map((item) =>
          item.stockLinkId === updatedData.stockLinkId
            ? {
                ...item,
                stockLeft: Number((item.stockLeft - updatedData.quantity).toFixed(3)),
              }
            : item,
        ),
      );

      setRecentStock((prevStock) =>
        prevStock.map((item) =>
          item.stockLinkId === updatedData.stockLinkId
            ? {
                ...item,
                stockLeft: item.stockLeft - updatedData.quantity,
              }
            : item,
        ),
      );

      showAlert("success", Messages.SUCCESS.STOCK_UPDATED);
      closeStockOutModal();
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

  const handleStockTrash = async (updatedData, quantity, remarks,selectedUnit) => {
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const data = {
        productid: updatedData.productid,
        stockid: updatedData._id,
        // stocklid: updatedData.stocklid,
        ...(remarks && { remarks }),
        // quantity: Number(updatedData?.isSecondaryUnit?primaryQuanity(quantity,updatedData?.unitConfig):quantity),
        quantity: Number(
          updatedData?.isSecondaryUnit &&
          selectedUnit === updatedData?.unitConfig?.secondaryUnitCode
            ? primaryQuanity(quantity, updatedData?.unitConfig)
            : quantity
        ),
      };
      const response = await AxiosInstance.delete(
        `module/stock/trash/${updatedData.stockLinkId}`,
        { data },
      );
      var index = updatedData.cIndex;
      updatedData = response.data.results;

      setStockData((prevStock) =>
        prevStock.map((item) =>
          item.productid === updatedData.productid
            ? {
                ...item,
                stockLeft: Number((item.stockLeft - updatedData.quantity).toFixed(2)),
              }
            : item,
        ),
      );

      setRecentStock((prevStock) =>
        prevStock.map((item) =>
          item.productid === updatedData.productid
            ? {
                ...item,
                stockLeft: Number((item.stockLeft - updatedData.quantity).toFixed(2)),
              }
            : item,
        ),
      );

      //   setRecentStock((prev)=>{
      //    const savedStocks = JSON.parse(localStorage.getItem("recentStocks")) || [];
      //     const updatedStocks = savedStocks.map((item) =>
      //     item.productid === updatedData.productid
      //         ? { ...item, stockLeft: item.stockLeft - updatedData.quantity }
      //         : item
      //     );
      //     localStorage.setItem("recentStocks", JSON.stringify(updatedStocks));
      //     return updatedStocks
      // })

      // setFilteredData((prevFiltered) => {
      //   if (prevFiltered[index]?._id === updatedData._id) {
      //     const updatedFiltered = [...prevFiltered];
      //     updatedFiltered[index] = { ...prevFiltered[index], ...updatedData };
      //     return updatedFiltered;
      //   }
      //   return prevFiltered.map((item) =>
      //     item._id === updatedData._id ? { ...item, ...updatedData } : item
      //   );
      // });
      showAlert("success", Messages.SUCCESS.STOCK_TRASHED);
      closeStockOutModal();
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

  const handleRecentStock = async (page = 0) => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(
        `module/stock?pageno=${page + 1}&limit=${perPage}`,
      );
      setStockData(response.data.results);
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  const handleSetRecentStock = (product, title, code) => {
    const updatedProduct = {
      ...product,
      title,
      code,
      stockLeft:product?.stockIn,   
      stockLeftUnit:product?.isSecondaryUnit?product?.unitConfig?.secondaryUnitCode:product?.unitConfig?.primaryUnitCode
    };
    setStockData((prev) => [updatedProduct, ...prev.slice(0, 9)]);
    setRecentStock((prev) => {
      const prevs = localStorage.getItem("recentStocks");
      const updatedStocks = [updatedProduct, ...prev.slice(0, 9)]; // Keep only latest 10
      localStorage.setItem("recentStocks", JSON.stringify(updatedStocks));
      return updatedStocks;
    });
  };

  // const secondaryQuanity=(quanity,unitData)=>{
  //   const qty=toSecondaryQuantity(quanity, unitData);
  //   return qty?.secondaryQty;
  // }


  const handleBack = () => {
    navigate(navigatelist || "/dashboard");
    onDone?.();
  };

  useEffect(() => {
    handleRecentStock();
  }, []);
  const handleSearchOpen = (status) => {
    setSearchOpen(status);
  };

  useKeyboardTableNavigation({
    modals: {
      searchOpen,
      isStockEditModalOpen,
      isStockOutModalOpen,
      isStockInModalOpen,
      globelPopupOpen,
      noteOpen,
      isAnyInputFocused,
    },
    onEnter: openEditModal,
  });

  const handleUpdte = async (updatedData, imageFile, trigger = true) => {
    const original = isProductEditData;
  
    const formData = new FormData();
    let isDataChanged = false;
  
    const appendIfChanged = (key, newVal, oldVal, transform = (v) => v) => {
      if (newVal !== oldVal) {
        formData.append(key, transform(newVal));
        isDataChanged = true;
      }
    };
  
      const isPriceGroupChanged =
      updatedData?.mrp !== original?.mrp ||
      updatedData?.saleprice !== original?.saleprice ||
      updatedData?.baseprice !== original?.baseprice ||
      updatedData?.taxpercentage !== original?.taxpercentage ||
      updatedData?.isLock !== original?.isLock;

    if (isPriceGroupChanged) {
      formData.append(
        "mrp",
        CurrencyConverter.toSubunit(updatedData?.mrp, "INR")
      );
      formData.append(
        "saleprice",
        CurrencyConverter.toSubunit(updatedData?.saleprice, "INR")
      );
      formData.append(
        "baseprice",
        CurrencyConverter.toSubunit(updatedData?.baseprice, "INR")
      );
      formData.append("taxpercentage", updatedData?.taxpercentage);
      formData.append("isLock", updatedData?.isLock);

      isDataChanged = true;
    }

    appendIfChanged("code", updatedData?.code, original?.code);
    appendIfChanged("hsnsac", updatedData?.hsnsac ?? "", original?.hsnsac ?? "");
    appendIfChanged("title", updatedData?.title, original?.title);
    // appendIfChanged("taxpercentage", updatedData.taxpercentage, original.taxpercentage);
    // appendIfChanged("isLock", updatedData.isLock, original.isLock);
    appendIfChanged("note", updatedData?.note, original?.note);
    appendIfChanged("searchTag", updatedData?.searchTag ?? "", original?.searchTag ?? "");
    appendIfChanged("brandId",updatedData?.brandData?.title??"",original?.brandId??"");
    // appendIfChanged("mrp",updatedData.mrp,original.mrp,(v) => CurrencyConverter.toSubunit(v, "INR"));
    // appendIfChanged("saleprice",updatedData.saleprice,original.saleprice,(v) => CurrencyConverter.toSubunit(v, "INR"));
    // appendIfChanged("baseprice",updatedData.baseprice,original.baseprice,(v) => CurrencyConverter.toSubunit(v, "INR"));
    appendIfChanged("landingcost",updatedData?.landingcost || 0,original?.landingcost || 0,(v) => CurrencyConverter.toSubunit(v, "INR"));
  
    const newUnit = updatedData?.unitConfig;
    const oldUnit = original?.unitConfig;
  
    if (
      !updatedData?.unitLocked &&
      JSON.stringify(newUnit) !== JSON.stringify(oldUnit)
    ) {
      formData.append("unitConfig", JSON.stringify(newUnit));
      isDataChanged = true;
    }
    if (imageFile instanceof File) {
      formData.append("primaryImage", imageFile);
      isDataChanged = true;
    }
  
    if (!isDataChanged) {
      showAlert("success", Messages.SUCCESS.PRODUCT_UPDATED);
      if (trigger) closeProductEditModal();
      return true;
    }
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
  
      const response = await AxiosInstance.patch(
        `module/product/update-product/${updatedData._id}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
  
      showAlert("success", Messages.SUCCESS.PRODUCT_UPDATED);
      await handleRecentStock();
      setProductData((prev) =>
        prev.map((p) =>
          p._id === response.data.results?._id
            ? response.data.results
            : p
        )
      );
      setProductStockData(response.data.results)
      if (trigger) closeProductEditModal();
      return true;
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

  // useEffect(() => {
  //     const savedStocks = JSON.parse(localStorage.getItem("recentStocks")) || [];
  //     setRecentStock(savedStocks);
  //     console.log("savedStocks",savedStocks)
  //   }, []);

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    handleSuggestNote();
    handleBrandSuggest();
  }, []);

  return (
    <>
      <div>
        <div className="page-wrapper">
          <div className="page-content">
            <div className="row">
              <div className="col-lg-5">
              <div className="d-flex align-items-center">
                <button
                  type="button"
                  className="btn btn-teal text-right"
                  onClick={handleBack}
                >
                  <ArrowBackIcon/>
                </button> 
                <h6 className="card-title ms-2">Add Stock </h6>
                </div>
                <AddStock
                  isActive={isActive}
                  ListRecentStock={handleRecentStock}
                  handleSetRecentStock={handleSetRecentStock}
                  searchOpen={handleSearchOpen}
                  noteOpenStatus={handleNoteOpen}
                  navigatelist={handleBack}
                  noteSuggests={noteSuggest}
                  setIsAnyInputFocused={setIsAnyInputFocused}
                  brandSuggest={brandSuggest}
                  setBrandSuggest={setBrandSuggest}
                  editData={isProductEditData}
                  onClose={closeProductEditModal}
                  onEdit={handleUpdte}
                  isBtnLoad={isBtnLoading}
                  isEditModalOpen={isEditModalOpen}
                  setEditModalOpen={setEditModalOpen}
                  setProductEditData={setProductEditData}
                  productStockData={productStockData}
                />
              </div>
              <div className="col-lg-7">
                <h6 className="card-title ">Recently Added Stock </h6>
                <div className="card radius-10 mb-0 mt-3">
                  <div className="card-body px-0">
                    <Table
                      loading={isLoading}
                      data={isStockData}
                      trClass={true}
                      onRowClick={(item, index) => openEditModal(item, index)}
                      columns={[
                        {
                          label: "SKU Code",
                          render: (item) => (
                            <span className="badge rounded-pill bg-label-navy">
                              {item.code}
                            </span>
                          ),
                        },
                        {
                          label: "Title",
                          render: (item) => (
                            <span className="text-heading fw-medium text-wrap text-left">
                              {item.title}{" "}
                            </span>
                          ),
                        },
                        {
                          label: "Sale Price",
                          render: (item) => (
                            <span className="text-right p-2">
                              
                              {formatCurrencyFun(item?.saleprice)}
                            </span>
                          ),
                        },
                        {
                          label: "LandingCost",
                          render: (item) => (
                            <span className="badge bg-label-peace text-right">
                              
                              {formatCurrencyFun(item?.landingcost)}
                            </span>
                          ),
                        },
                        // {
                        //   label: "Unit",
                        //   render: (item) => (
                        //     <span className="badge btn-unit">
                        //       {item?.stockInUnit==="unit"?"": item?.stockInUnit}
                        //     </span>
                        //   ),
                        // },
                        {
                          label: "Stock In",
                          thClass:"w-15",
                          render: (item,index) => (
                            <div className="no-print position-relative">
                          <div className=" d-flex justify-content-center align-items-center">
                            <span className="stock-status-badge badge bg-label-spring">
                              {Number(item?.isSecondaryUnit
                                ? secondaryQuanity(item.stockIn,item?.unitConfig)
                                : item?.stockIn)}
                              <span className="font-11 ms-1">
                              {
                                (() => {
                                  const unitCode = item?.isSecondaryUnit
                                    ? item?.unitConfig?.secondaryUnitCode
                                    : item?.unitConfig?.primaryUnitCode;

                                  // return unitCode !== "unit" ? unitCode : "";
                                  return unitCode ;
                                })()
                              }
                                  </span>
                            </span>
                            <div className="order-actions order-actions3 opacity-0 ">
                            <button
                                type="button"
                                className="btn-label-primary shadow-none me-2"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleClickBarcode(item);
                                }}
                              >
                                <BarcodeIcon/>
                              </button>
                              <button
                                type="button"
                                className="btn-label-danger shadow-none"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  openDeleteTrashModal(item, index);
                                }}
                              >
                                <DeleteIcon/>
                              </button>
                              </div>
                            </div>
                            </div>
                          ),
                        },
                        // {
                        //   label: "Actions",
                        //   render: (item, index) => (
                        //     <div className="order-actions opacity-0 opacity-md-100">
                        //       <button
                        //         type="button"
                        //         className="btn-label-primary shadow-none me-2"
                        //         onClick={(e) => {
                        //           e.stopPropagation();
                        //           handleClickBarcode(item);
                        //         }}
                        //       >
                        //         <i className="bx bx-barcode"></i>
                        //       </button>
                        //       <button
                        //         type="button"
                        //         className="btn-label-danger shadow-none"
                        //         onClick={(e) => {
                        //           e.stopPropagation();
                        //           openDeleteTrashModal(item, index);
                        //         }}
                        //       >
                        //         <i className="ng ng-ng-delete-icon"></i>
                        //       </button>
                        //     </div>
                        //   ),
                        // },
                      ]}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isStockEditModalOpen && (
        <EditStock
          isActive={isActive}
          editData={isStockEditData}
          onClose={closeEditModal}
          onEdit={handleUpdate}
          isBtnLoading={isBtnLoading}
        />
      )}

      {isStockInModalOpen && (
        <StockIn
          data={isStockInData}
          onClose={closeStockInModal}
          onEdit={handleStockIn}
          isBtnLoading={isBtnLoading}
        />
      )}

      {isStockOutModalOpen && (
        <StockOut
          data={isStockOutData}
          onClose={closeStockOutModal}
          onEdit={handleStockTrash}
          isBtnLoading={isBtnLoading}
        />
      )}
      {showBarcodeModal && uRLs.BARCODE_PRINT === "true" && (
        <BarcodeGenerator
          barcodeValue={selectedBarcode.code}
          product={selectedBarcode}
          onClose={() => setShowBarcodeModal(false)}
        />
      )}
    </>
  );
};
export default Stock;
